import { useFadeUp } from '@/hooks/useFadeUp';
import { useTranslation } from "react-i18next";

export default function CTA() {
  const { t } = useTranslation();
  const { ref, visible } = useFadeUp();

  const scrollToForm = () => {
    const el = document.querySelector("#diagnostico");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="relative py-4 md:py-6 bg-background-50">
      <div ref={ref} className={`max-w-6xl mx-auto px-6 md:px-10 fade-up-hidden ${visible ? 'fade-up-visible' : ''}`}>
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-800 via-primary-900 to-primary-950 p-10 md:p-16">
          <div className="absolute -top-24 -right-24 w-[400px] h-[400px] radial-glow opacity-50"></div>
          <div className="absolute inset-0 grid-pattern opacity-15"></div>

          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/15 text-accent-300 text-xs font-semibold border border-accent-500/25">
                <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulseGlow"></span>
                {t("cta.badge")}
              </span>
              <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
                {t("cta.h2_part1")}<span className="brand-gradient-text">{t("cta.h2_gradient")}</span>{t("cta.h2_part3")}
              </h2>
              <p className="mt-4 text-background-200/85 text-base md:text-lg max-w-xl">
                {t("cta.description")}
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch gap-3 w-full lg:w-auto">
              <button
                onClick={scrollToForm}
                className="group px-6 py-3.5 rounded-md text-sm font-semibold text-background-50 brand-gradient-btn cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                {t("cta.button")}
                <span className="w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-1">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}